module.exports = __webpack_public_path__ + "img/image 51.b24b8f84.svg";